import React, { Component } from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styled from "styled-components";
import Filter from "../../../../components/BookingForm/Filter/Filter";

const Container = styled.div`
  display: flex;
`;

class TabFilter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      tabFilters,
      propertyActiveTab,
      onChange,
      onSelectorChange,
      isTabFiltersCollapsed,
    } = this.props;

    if (!tabFilters) {
      return null;
    }

    return (
      <Container className="wbkv9-RoomSelection-TabFilter">
        {tabFilters.map((tabFilter, idx) => (
          <Filter
            key={idx}
            filter={tabFilter}
            selected={propertyActiveTab && propertyActiveTab.get("optionTicker")}
            handleChange={onChange}
            isTabFiltersCollapsed={isTabFiltersCollapsed}
            handleSelectorChange={onSelectorChange}
          />
        ))}
      </Container>
    );
  }
}

TabFilter.propTypes = {
  /** Prop which holds the property information */
  tabFilters: PropTypes.object.isRequired,
  /** The component can have different appearances depending on this prop  */
  propertyActiveTab: PropTypes.object.isRequired,
  /** Function to be executed when clicking the back button */
  onChange: PropTypes.func.isRequired,
  /** Function to be executed when clicking in the result's header */
  onSelectorChange: PropTypes.func.isRequired,
  /** Filter node / content */
  isTabFiltersCollapsed: PropTypes.bool.isRequired,
};

TabFilter.defaultProps = {};

export default pure(TabFilter);
